import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useFucionalidadesMenusList() {
  // Use toast
  const toast = useToast()

  const refGrupoListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'title', sortable: true, label: 'Titulo' },
    { key: 'order', sortable: true, label: 'Ordem Cliente' },
    { key: 'icon', sortable: true, label: 'Icone Cliente' },
    { key: 'route', sortable: true, label: 'Rota Cliente' },
    { key: 'ativo', sortable: true, label: 'Status' },
    { key: 'actions', label: 'Ações' },
  ]
  const perPage = ref(10)
  const totalMenusFucionalidades = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 15, 20, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id_menu')
  const isSortDirDesc = ref(true)
  const statusFilter = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refGrupoListTable.value ? refGrupoListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalMenusFucionalidades.value,
    }
  })

  const refetchData = () => {
    refGrupoListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const getStatus = status => {
    if (['1', 1, 'active', 'ativo', true, 'true'].indexOf(status) !== -1) {
      return 1
    }
    if (['0', 0, 'inactive', 'inativo', false, 'false'].indexOf(status) !== -1) {
      return 0
    }
    return null
  }

  const fetchMenus = (ctx, callback) => {
    store
      .dispatch('app-adm-menus/fetchMenus', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        ativo: getStatus(statusFilter.value),
      })
      .then(response => {
        const { menus, total } = response.data

        callback(menus)
        totalMenusFucionalidades.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 1) return 'success'
    if (status === 0) return 'secondary'
    return 'primary'
  }

  return {
    fetchMenus,
    tableColumns,
    perPage,
    currentPage,
    totalMenusFucionalidades,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refGrupoListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    statusFilter,
  }
}
